<div class="filters" *ngIf="Origin != 'miArea'">
  <div class="row">
    <div class="col-md-3 mb-3">
      <select2 id="statusOrder" [(ngModel)]="defaultStatus" [data]="statusList" class="select2"></select2>
    </div>
    <div class="col-md-4 mb-3">
      <select2 id="distribOrder" [(ngModel)]="defaultDistrib" [data]="distributorsList" class="select2"></select2>
    </div>
    <div class="col-auto mb-3"><button class="btn-search" (click)="rerender()">Filtro</button></div>
  </div>
</div>

<div *ngIf="totalCampaignCount" [@loadedHeightAnimation]="'visible'" class="highlights row-3-1 mt-2 mb-5">
  <div class="col">
    <div class="card">
      <div class="card-title">
        Total campanhas
      </div>
      <div class="card-body with-icon mt-3">
        <img src="/assets/images/icons/ico-campannas.svg" /> <span class="text-lg-1">{{totalCampaignCount.Total}}</span>
      </div>
    </div>
  </div>

  <div class="col">
    <div class="card">
      <div class="card-title">
        Campanhas E-mails
      </div>
      <div class="card-body with-icon mt-3">
        <img src="/assets/images/icons/ico-sobre.svg" /> <span class="text-lg-1">{{totalCampaignCount.Email}}</span>
      </div>
    </div>
  </div>

  <div class="col">
    <div class="card">
      <div class="card-title">
        Campanhas SMS
      </div>
      <div class="card-body with-icon mt-3">
        <img src="/assets/images/icons/ico-sms.svg" /> <span class="text-lg-1">{{totalCampaignCount.Sms}}</span>
      </div>
    </div>
  </div>
</div>

<h5>Histórico de pedidos</h5>
<div id="tbl_order_crm_">
  <input [(ngModel)]="hdd_origin" type="hidden" id="hddn_origin_crm" value="" />
  <div class="table-responsive-lg fadein-table">
    <table id="tblEvaluation" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table data-tables dataTable condensed-table no-footer">
      <thead>
        <tr>
          <th class="w-8">Código </th>
          <th class="w-12">Concessionário</th>
          <th class="w-12">Utilizador</th>
          <th class="w-6 text-center">Número de pedido</th>
          <th class="w-6 text-center">Data de pedido</th>
          <th class="text-center">Campanha</th>
          <th class="w-8 text-center">Contactos</th>
          <th class="w-8 text-center">Materiais</th>
          <th class="w-8 text-center">Estado</th>
          <th class="w-8 text-center">Data de envio desejada</th>
          <th class="w-8 text-center">Opções</th>
        </tr>
      </thead>
    </table>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Envio de teste</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <p>Teste o envio desta campanha introduzindo aqui o número de telemóvel/e-mail. Pode introduzir vários números separados por vírgulas. <strong> Custo de envio de SMS de teste: 0,030€ por contacto.</strong> A STIHL irá deduzir este valor das suas faturas de forma semestral.</p>
    <div [ngClass]="{'was-validated': showErrorEmailNoValid}" class="w-100 mt-2 mb-4"><input [ngClass]="{'is-invalid': showErrorEmailNoValid}" type="text" [(ngModel)]="emailTest" class="w-100" />
      <div *ngIf="showErrorEmailNoValid != ''" class="invalid-feedback">Debe ingresar un correo valido</div>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="sendEmailTest()" class="btn-orange">Enviar</button>
  </div>
</ng-template>

<!-- <div class="divModalEmail mt-4" *ngIf="showModalEmail">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Envio de teste</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">&times;</button>
    </div>
    <div class="modal-body">
      <p>Teste o envio desta campanha introduzindo aqui o número de telemóvel/e-mail. Pode introduzir vários números separados por vírgulas.</p>
      <div class="w-100 mt-2 mb-4"><input type="text" [(ngModel)]="emailTest" class="w-100" /></div>
      <div *ngIf="showErrorEmailNoValid != ''" class="text-error mb-4">Debe ingresar un correo valido</div>
    </div>
    <div class="modal-footer">
      <button (click)="sendEmailTest()" class="btn-orange">Enviar</button>
    </div>
  </div>
</div> -->